import React, { FunctionComponent } from 'react';
import type { RecruitmentShowBottomItemTagsProps } from './types';
import type { OccupationDetailItem, OccupationItem, OtherOccupationItem } from '../../../types/recruitmentShow';

type Props = RecruitmentShowBottomItemTagsProps & {
  occupations: OccupationItem[];
  occupationDetails: OccupationDetailItem[];
  prefecture: string;
  prefectureUrl: string;
  city: string;
  cityId: number | null;
  otherOccupations: OtherOccupationItem[];
  multiple: boolean;
};

export const Presentation: FunctionComponent<Props> = ({
  title,
  recruitmentId,
  isStopped,
  dataCategory,
  dataValue,
  occupations,
  occupationDetails,
  prefecture,
  prefectureUrl,
  city,
  cityId,
  otherOccupations,
  multiple,
  isPreview
}) => {

  return (
    <div className="recruitment__show__bottom__wrapper__content last">
      <h2 className="mainTitle">{title}</h2>

      {occupations.length > 0 && (
        <div className="recruitment__show__bottom__wrapper__inner">
          <h3 className="subTitle">勤務地 × 職種</h3>

          <div className="recruitment__show__bottom__wrapper__content__wordList mb gtm-recruitment_navigation-view-count" data-event-name='recruitment_navigation on screen' data-category={isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent} data-value={dataValue.recruitmentJoblocationOccupation}>
            {occupations.map((o) => (
              <a
                key={o.id}
                href={`/${o.url}`}
                target="_blank"
                rel="noopener noreferrer"
                className="link"
                {...(!isPreview && {
                  'data-event': 'click',
                  'data-category': isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent,
                  'data-value': dataValue.recruitmentJoblocationOccupation
                })}
              >
                {o.title}
              </a>
            ))}
          </div>

          {occupationDetails.length > 0 && (
            <div className="recruitment__show__bottom__wrapper__content__wordList mbb gtm-recruitment_navigation-view-count" data-event-name='recruitment_navigation on screen' data-category={isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent} data-value={dataValue.recruitmentJoblocationOccupationDetail}>
              {occupationDetails.map((od) => (
                <a
                  key={od.id}
                  href={`/${od.url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link"
                  {...(!isPreview && {
                    'data-event': 'click',
                    'data-category': isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent,
                    'data-value': dataValue.recruitmentJoblocationOccupationDetail
                  })}
                >
                  {od.title}
                </a>
              ))}
            </div>
          )}
        </div>
      )}

      <h3 className="subTitle">その他</h3>
      <div className="recruitment__show__bottom__wrapper__content__wordList gtm-recruitment_navigation-view-count" data-event-name='recruitment_navigation on screen' data-category={isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent} data-value={dataValue.recruitmentOtherJoblocationPrefecture}>
        {!multiple && prefectureUrl && (
          <div className="smallBox">
            <a
              href={`/${prefectureUrl}`}
              target="_blank"
              rel="noopener noreferrer"
              {...(!isPreview && {
                'data-event': 'click',
                'data-category': isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent,
                'data-value': dataValue.recruitmentOtherJoblocationPrefecture
              })}
            >
              {prefecture}
            </a>
            {city && (
              <>
                <span className="devide">&gt;</span>
                <a
                  href={`/cities/${cityId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className='gtm-recruitment_navigation-view-count'
                  {...(!isPreview && {
                    'data-event-name': 'recruitment_navigation on screen',
                    'data-event': 'click',
                    'data-category': isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent,
                    'data-value': dataValue.recruitmentOtherJoblocationCity
                  })}
                >
                  {city}
                </a>
              </>
            )}
          </div>
        )}

        {otherOccupations.map((o) => (
          <div className="smallBox" key={o.occupationUrl}>
            <a
              href={`/${o.occupationUrl}`}
              target="_blank"
              rel="noopener noreferrer"
              className='gtm-recruitment_navigation-view-count'
              {...(!isPreview && {
                'data-event-name': 'recruitment_navigation on screen',
                'data-event': 'click',
                'data-category': isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent,
                'data-value': dataValue.recruitmentOtherOccupation
              })}
            >
              {o.occupation}
            </a>
            {o.occupationDetail && (
              <>
                <span className="devide">&gt;</span>
                <a
                  href={`/${o.occupationDetailUrl}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className='gtm-recruitment_navigation-view-count'
                  {...(!isPreview && {
                    'data-event-name': 'recruitment_navigation on screen',
                    'data-event': 'click',
                    'data-category': isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent,
                    'data-value': dataValue.recruitmentOtherOccupationDetail
                  })}
                >
                  {o.occupationDetail}
                </a>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
